import React, { useState } from 'react'
import { CSVLink } from "react-csv";
import { Page, Card, DataTable, Heading, DisplayText, Icon, TextField, Spinner } from '@shopify/polaris';
import { useSelector, useDispatch } from 'react-redux'
import { Link } from "react-router-dom";
import actionTypes from '../../../store/actionTypes';
import ReplaceProduct from '../ReplaceProduct';
import ActionsList from '../../ActionsList';
import ModalComponent from "../../ModalComponent";
import Loader from '../../Loader';
import axios from 'axios';
import { CircleLeftMajor } from '@shopify/polaris-icons';
import CountDownTimerC from '../../CountDownTimer';
import htmlToPdfmake from "html-to-pdfmake";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const ViewPurchaseOrder = props => {

    const { viewOrder, viewProduct, updateOrder, savePurchaseOrders } = actionTypes
    const dispatch = useDispatch()
    const { serverLink, moneyFormat, shopId } = useSelector(state => state.ConfigReducer)
    const { purchaseOrders, order, product, itemStatus, replacedProduct } = useSelector(state => state.POReducer)

    const [OrderSubmitting, setOrderSubmitting] = useState(false)
    const [DownloadingPDF, setDownloadingPDF] = useState(false)
    const [DownloadingCSV, setDownloadingCSV] = useState(false)
    const [Replace, setReplace] = useState(false)

    const [EditNotes, setEditNotes] = useState({})
    const [Notes, setNotes] = useState({})
    const [OldNotes, setOldNotes] = useState({})
    const [NotesUpdating, setNotesUpdating] = useState({})
    const [ReplacingProduct, setReplacingProduct] = useState(false)

    const handleChange = (field, value) => {
        setNotes({ ...Notes, [field]: value })
    }
    const handleEdit = (field, value) => {
        setEditNotes({ ...EditNotes, [field]: value })
    }

    const updateProductNotes = (id, requestData, orderId) => {
        const ifConnected = window.navigator.onLine;
        if (ifConnected) {
            setNotesUpdating({ ...NotesUpdating, [id]: true })
            const options = {
                method: 'PUT',
                url: `${serverLink}/order/item/update/${id}/${shopId}`,
                data: requestData
            }
            axios(options).then(({ data }) => {
                if (data) {
                    const orders = purchaseOrders
                    for (const i in orders) {
                        if (orders[i].id === orderId) {
                            const po = orders[i]
                            for (const j in po.purchaseorderitems) {
                                if (po.purchaseorderitems[j].id === id) {
                                    po.purchaseorderitems[j].notes = requestData.notes
                                }
                            }
                        }
                    }
                    dispatch({ type: savePurchaseOrders, payload: orders })
                    setNotesUpdating({ ...NotesUpdating, [id]: false })
                    handleEdit(id, false)
                }
            }).catch(error => {
                handleChange(id, '-')
                handleEdit(id, false)
                setNotesUpdating({ ...NotesUpdating, [id]: false })
                console.log("error", error)
                alert(error)
            })
        } else {
            alert("Please, Check Your Internet Connection!")
        }
    }

    const sendRequest = async options => {
        return await axios(options)
            .then(({ data }) => {
                if (data) {
                    return data
                }
            }).catch(error => {
                console.log("error", error)
                alert(error)
                return false
            })
    }
    const replaceProduct = async (newProduct, oldProduct, order) => {
        const ifConnected = window.navigator.onLine;
        if (ifConnected) {
            setReplacingProduct(true)
            const SameVendor = newProduct.product.vendor === order.vendor.name
            const prod = {
                barcode: newProduct.barcode,
                costPerUnit: Number(newProduct.price),
                costPlusTax: Number(newProduct.price) * 0.2,
                description: newProduct.product.title,
                id: oldProduct.id,
                image: newProduct.product.featuredImage ? newProduct.product.featuredImage.src : null,
                internalRef: oldProduct.internalRef,
                notes: oldProduct.notes,
                orderId: oldProduct.orderId,
                orderNumber: oldProduct.orderNumber,
                patNum: oldProduct.patNum,
                purchaseorderId: order.id,
                qty: oldProduct.qty,
                received: oldProduct.received,
                shopId: shopId,
                status: oldProduct.status,
                variantId: newProduct.id,
            }
            if (SameVendor && order.status === 'null') {
                const options = {
                    method: 'PUT',
                    url: `${serverLink}/order/item/update/${oldProduct.id}/${shopId}`,
                    data: prod
                }
                const isUpdated = await sendRequest(options)
                if (isUpdated) {
                    setReplacingProduct(false)
                    const pos = purchaseOrders
                    for (const i in pos) {
                        if (pos[i].id === order.id) {
                            for (const j in pos[i].purchaseorderitems) {
                                if (pos[i].purchaseorderitems[j].id === oldProduct.id) {
                                    pos[i].purchaseorderitems.splice(j, 1, prod)
                                }
                            }
                        }
                    }
                    dispatch({ type: savePurchaseOrders, payload: pos })

                    for (const i in order.purchaseorderitems) {
                        if (order.purchaseorderitems[i].id === oldProduct.id) {
                            order.purchaseorderitems.splice(i, 1, prod)
                        }
                    }
                    dispatch({ type: viewOrder, payload: order })
                    dispatch({ type: viewProduct, payload: {} })
                }
            } else if (!SameVendor) {
                const options = {
                    method: 'POST',
                    url: `${serverLink}/order/purchaseOrders/${newProduct.product.vendor}/${shopId}`,
                    data: prod
                }
                const response = await sendRequest(options)
                const pos = purchaseOrders
                if (response.createdProduct) {
                    for (const i in pos) {
                        if (pos[i].id === response.createdProduct.purchaseorderId) {
                            pos[i].purchaseorderitems.push(response.createdProduct)
                        }
                        if (pos[i].id === order.id) {
                            for (const j in pos[i].purchaseorderitems) {
                                if (pos[i].purchaseorderitems[j].id === oldProduct.id) {
                                    pos[i].purchaseorderitems[j].status = 're'
                                }
                            }
                        }
                    }
                } else if (response.createdOrder) {
                    pos.unshift(response.createdOrder)
                    for (const i in pos) {
                        if (pos[i].id === order.id) {
                            for (const j in pos[i].purchaseorderitems) {
                                if (pos[i].purchaseorderitems[j].id === oldProduct.id) {
                                    pos[i].purchaseorderitems[j].status = 're'
                                }
                            }
                        }
                    }
                }
                dispatch({ type: savePurchaseOrders, payload: pos })
                dispatch({ type: viewProduct, payload: {} })
                setReplacingProduct(false)
            }
        } else {
            alert("Please, Check Your Internet Connection!")
        }
    }

    if (Object.keys(order).length > 0) {
        const products = order.purchaseorderitems
        const cost = moneyFormat.replace("{{amount}}", order.costValue.toString())

        const orderDataRows = [
            ['Supplier:', <Heading>{order.vendor.name}</Heading>],
            ['Cost of Order:', <Heading>{cost}</Heading>],
            // ['Cutoff Time:', <Heading>{order.timeUntilCutoff}</Heading>],
            ['Cutoff Time:', <Heading><CountDownTimerC cutoff={order.timeUntilCutoff} /></Heading>],
            ['Submitted:', <Heading>{order.submittedAt}</Heading>],
            ['Created:', <Heading>{order.createdAt}</Heading>],
        ];
        const csvList = []
        const productDataRows = products.map((product, index) => {
            if (Notes[product.id] === undefined && EditNotes[product.id] === undefined) {
                handleChange(product.id, product.notes === '' || product.notes === null ? '-' : product.notes)
                handleEdit(product.id, false)
            }

            csvList.push({ code: product.barcode, quantity: product.qty })

            const pCost = moneyFormat.replace("{{amount}}", product.costPerUnit)

            const actionsList = [
                {
                    content: 'View',
                    onAction: () => {
                        setReplace(false)
                        dispatch({ type: viewProduct, payload: product })
                    },
                },
                {
                    content: 'Replace',
                    onAction: () => {
                        setReplace(true)
                        dispatch({ type: viewProduct, payload: product })
                    },
                }
            ]
            return [
                product.barcode, <span style={{ display: 'inline-block', maxWidth: '300px', whiteSpace: 'normal' }}>{product.description}</span>, product.orderNumber, pCost, product.qty,
                <span>{
                    EditNotes[product.id] ? <TextField labelHidden focused={true} name="notes" label="Add Notes" placeholder="Add Notes" type="text"
                        value={Notes[product.id]}
                        onFocus={() => {
                            if (product.notes === '' || product.notes === null) {
                                handleChange(product.id, '')
                            }
                            setOldNotes({ ...OldNotes, [product.id]: product.notes })
                        }}
                        onChange={value => handleChange(product.id, value)}
                        onBlur={() => {
                            if ((Notes[product.id] === '' || Notes[product.id] === undefined) && (OldNotes[product.id] === '' || OldNotes[product.id] === null)) {
                                handleChange(product.id, '-')
                                handleEdit(product.id, false)
                            } else if (Notes[product.id] === OldNotes[product.id]) {
                                handleChange(product.id, OldNotes[product.id])
                                handleEdit(product.id, false)
                            } else {
                                updateProductNotes(product.id, { notes: Notes[product.id] }, order.id)
                            }
                        }}
                        suffix={NotesUpdating[product.id] ? <Spinner accessibilityLabel="notes spinner" size="small" /> : null}
                    /> : <span style={{ display: 'inline-block', maxWidth: '300px', whiteSpace: 'normal' }} onClick={() => handleEdit(product.id, true)}>{Notes[product.id]}</span>
                }</span>,
                itemStatus[product.status], <ActionsList actionsList={actionsList} />
            ]
        })
        const headers = [
            { label: "Code", key: "code" },
            { label: "Qty", key: "quantity" },
            // { label: "Name", key: "name" },
            // { label: "For Orders", key: "forOrders" },
            // { label: "Line Cost", key: "lineCost" },
            // { label: "Notes", key: "notes" },
            // { label: "Qty Submitted", key: "quantitySubmitted" },
            // { label: "Amt Recieved", key: "amountRecieved" },
            // { label: "Status", key: "status" },
        ]
        const loaderStyle = {
            width: "10px",
            height: "10px",
            borderWidth: "2px",
            borderStyle: "solid",
            borderColor: "#1F77C4 #1F77C4 white",
        }
        return <Page
            fullWidth
        >
            <Card
                title={`Purchase Order #${order.id}`}
                subdued
                actions={[
                    {
                        content: <Link to="/orders"><Icon source={CircleLeftMajor} color="base" /></Link>, onAction: () => dispatch({ type: viewOrder, payload: {} })
                    },
                    {
                        content: OrderSubmitting ? <Loader style={loaderStyle} /> : 'Submit Order',
                        onAction: () => {
                            setOrderSubmitting(true)
                            const options = {
                                url: `${serverLink}/mail/send/${order.id}`,
                                method: 'GET',
                                // data: order
                            }
                            axios(options)
                                .then(({ data }) => {
                                    setOrderSubmitting(false)
                                    if (data.submittedAt) {
                                        const submittedDate = new Date(data.submittedAt)
                                        const submittedAt = `${submittedDate.toDateString()} ${submittedDate.getHours()}:${submittedDate.getMinutes()}`
                                        dispatch({ type: updateOrder, payload: { key: 'submittedAt', value: submittedAt } })
                                        const pos = purchaseOrders
                                        for (const po of pos) {
                                            if (po.id === order.id) {
                                                po.submittedAt = submittedAt
                                                po.status = 'sub'
                                            }
                                        }
                                        dispatch({ type: savePurchaseOrders, payload: pos })
                                    }
                                })
                                .catch(error => {
                                    setOrderSubmitting(false)
                                    console.log("error", error)
                                })
                        }
                    },
                    {
                        content: <a href={`${serverLink}/files/generatePDF/${order.id}`} target="_blank">Download PDF</a>
                    },
                    {
                        content: DownloadingCSV ? <Loader style={loaderStyle} /> : <CSVLink
                            data={csvList}
                            headers={headers}
                            filename={`${order.id}.csv`}
                        >
                            Submit & Download CSV
                        </CSVLink>,
                        onAction: () => {
                            setDownloadingCSV(true)
                            const options = {
                                url: `${serverLink}/order/submit/${order.id}`,
                                method: 'PUT',
                            }
                            axios(options).then(({ data }) => {
                                setDownloadingCSV(false)

                                if (data.submittedAt) {
                                    const submittedDate = new Date(data.submittedAt)
                                    const submittedAt = `${submittedDate.toDateString()} ${submittedDate.getHours()}:${submittedDate.getMinutes()}`
                                    dispatch({ type: updateOrder, payload: { key: 'submittedAt', value: submittedAt } })
                                    const pos = purchaseOrders
                                    for (const po of pos) {
                                        if (po.id === order.id) {
                                            po.submittedAt = submittedAt
                                            po.status = 'sub'
                                        }
                                    }
                                    dispatch({ type: savePurchaseOrders, payload: pos })
                                }
                            }).catch(error => {
                                setDownloadingCSV(false)
                                console.log("error", error)
                            })
                        }
                    },
                ]}
            >
                <Card.Section>
                    <DataTable
                        columnContentTypes={['text', 'text',]}
                        headings={['', '']}
                        rows={orderDataRows}
                    />
                </Card.Section>
                <Card.Section>
                    <DataTable
                        columnContentTypes={['text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'text',]}
                        headings={[<b>Code</b>, <b>Name</b>, <b>For Orders</b>, <b>Line Cost</b>, <b>Qty</b>, <b>Notes</b>, <b>Status</b>, <b>Actions</b>]}
                        rows={productDataRows}
                    />
                </Card.Section>
            </Card>
            <ModalComponent large={false}
                modalTitle={`Purchase Order #${order.id} -- Code #${product.barcode}`}
                active={Object.keys(product).length > 0}
                handleClose={() => dispatch({ type: viewProduct, payload: {} })}
                component={<ReplaceProduct replace={Replace} />}
                primaryAction={{
                    content: Replace ? (ReplacingProduct ? <Spinner accessibilityLabel="Replace Product" size="small" /> : 'Replace') : 'Back',
                    onAction: () => {
                        if (Replace) {
                            replaceProduct(replacedProduct, product, order)
                        } else {
                            dispatch({ type: viewProduct, payload: {} })
                        }
                    }
                }}
            />
        </Page >
    } else {
        return <DisplayText>No Order Selected! Go to <Link to="/orders">Orders</Link></DisplayText>
    }
}

export default ViewPurchaseOrder